import SettingsIcon from "@mui/icons-material/Settings";
import { styled } from "@mui/material";
import { SvgIconProps } from "@mui/material/SvgIcon";

// Transform is due to MUI Icon having space on the left, causing misaslignment with other icons in Drawer.
const StyledSettingsIcon = styled(SettingsIcon)`
  transform: translateX(-2px);
`;

const Settings: React.FC<SvgIconProps> = (props) => {
  return <StyledSettingsIcon {...props} />;
};

export default Settings;
